import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate'
import Vue from 'vue'
import { registerChangeLanguageCallback } from '@/i18n/i18n'

import {
  email,
  max,
  max_value, // eslint-disable-line camelcase
  min,
  min_value, // eslint-disable-line camelcase
  regex
} from 'vee-validate/dist/rules'

import required from './required'
import excluded from './excluded'
import { dateHigherThan, dateLowerThan } from './dates'
import { regexId, versionHigher, uniqueId } from './documentValidator'

// Add rules:
// https://vee-validate.logaretm.com/v3/guide/rules.html#importing-the-rules
extend('email', email)
extend('max', max)
extend('max_value', max_value)
extend('min', min)
extend('min_value', min_value)
extend('regex', regex)

// Custom
extend('required', required)
extend('date_higher_than', dateHigherThan)
extend('date_lower_than', dateLowerThan)
extend('regex_id', regexId)
extend('version_higher', versionHigher)
extend('unique', excluded)
extend('unique_id', uniqueId)

// Register components globally
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

// Exporting a callback for locale change (see i18n)
// see https://vee-validate.logaretm.com/v3/guide/localization.html#using-the-default-i18n
registerChangeLanguageCallback((localeName) => {
  import('vee-validate/dist/locale/' + localeName + '.json').then(locale => {
    localize(localeName, locale)
  })
})
